import { useMemo } from 'react';
import { isFinite, toNumber } from 'lodash';

export const usePurchaseOrderItems = (items, lookupCountryById) =>
    useMemo(() => {
        if (!Array.isArray(items)) return [];

        return items.map((item) => {
            const quantity = toNumber(item?.qty);
            const unitPriceNumber = toNumber(item?.unitPrice);
            const casesPerPallet = toNumber(item?.csPallet);
            const baseUnitsPerCase = toNumber(item?.baseUnitsPerCase ?? item?.purchasingCasePackSize);

            const id = item?.poMapID ?? item?.poMapId ?? item?.id ?? null;
            const normalizedUnitPrice =
                unitPriceNumber !== null ? unitPriceNumber.toFixed(2) : (item?.unitPrice ?? item?.casePrice ?? null);

            const totalUnits =
                isFinite(quantity) && isFinite(baseUnitsPerCase)
                    ? quantity * baseUnitsPerCase
                    : (item?.totalUnits ?? null);
            const totalCost =
                isFinite(quantity) && isFinite(unitPriceNumber)
                    ? (quantity * unitPriceNumber).toFixed(2)
                    : (item?.totalCost ?? null);

            const numPallets =
                isFinite(quantity) && isFinite(casesPerPallet) && casesPerPallet !== 0
                    ? Math.floor(quantity / casesPerPallet)
                    : (item?.numPallets ?? null);

            const countryId = item?.countryOfOriginId ?? item?.countryOfOriginID ?? null;
            const normalizedCountryId = countryId !== null && countryId !== undefined ? String(countryId) : undefined;
            const matchedCountry =
                normalizedCountryId && typeof lookupCountryById === 'function'
                    ? lookupCountryById(normalizedCountryId)
                    : null;

            return {
                ...item,
                id,
                unitPrice: normalizedUnitPrice,
                purchaseType: item?.purchaseType ?? '',
                totalUnits,
                totalCost,
                numPallets,
                countryOfOriginName: matchedCountry?.name ?? item?.countryOfOriginName ?? null,
                countryOfOriginCode: matchedCountry?.code ?? item?.countryOfOriginCode ?? null,
            };
        });
    }, [items, lookupCountryById]);
